import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import api from "@/lib/api";

export function Creative({ url, type = "IMAGE", className = "", testid = "creative-preview" }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoke;
    setFailed(false);
    if (!url) { setSrc(null); return; }
    if (url.startsWith("/api/files/")) {
      api.get(url.replace(/^\/api/, ""), { responseType: "blob" })
        .then((r) => { const u = URL.createObjectURL(r.data); revoke = u; setSrc(u); })
        .catch(() => setFailed(true));
    } else {
      setSrc(url);
    }
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [url]);

  if (!url || failed) {
    return (
      <div className={`flex items-center justify-center bg-secondary/50 rounded-md ${className}`} data-testid={testid}>
        <div className="text-center text-muted-foreground py-10">
          <ImageOff className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-xs">No creative uploaded</p>
        </div>
      </div>
    );
  }
  if (type === "VIDEO") {
    return <video src={src || undefined} controls playsInline className={`rounded-md bg-black ${className}`} data-testid={testid} />;
  }
  return <img src={src || undefined} alt="Campaign creative" className={`rounded-md object-cover ${className}`} data-testid={testid} />;
}

export default Creative;
